<template>
    <div>
        <v-row justify="center">
            <v-col cols="8">
        <v-card>

            <v-card-title class="justify-center" style="background-color: #e6e6e6;">
                <v-icon left>mdi-cogs</v-icon>
                Proficiência de Quartil
            </v-card-title>

            <v-card-text>

                <v-row dense class="justify-center">
                    <v-icon left>mdi-filter</v-icon>
                    <p style="margin-top: 15px; font-size: 20px;" class="font-weight-black">Selecione os dados</p>
                </v-row>

                <v-divider/>

                <br/>

                <v-row justify="center">
                    <v-col cols="9">
                        <v-select
                                :items="cidades"
                                item-text="nome"
                                v-model="cidadeSelecionada"
                                no-data-text="Nenhuma cidade encontrada"
                                label="Cidade"
                                solo
                        />
                    </v-col>
                </v-row>

                <v-row justify="center" style="margin-top: -20px;">
                    <v-col cols="9">
                        <v-select
                                :items="avaliacoes"
                                item-text="descricao"
                                v-model="avaliacaoSelecionada"
                                no-data-text="Nenhuma avaliação encontrada"
                                label="Avaliações"
                                solo
                        />
                    </v-col>
                </v-row>

                <v-row class="justify-center" style="margin-top: -25px;">
                    <v-btn dark color="primary" @click="graficos" >CONFIRMAR</v-btn>
                </v-row>
            </v-card-text>

        </v-card>
            </v-col>
        </v-row>

    </div>
</template>

<script>
    export default {
        data() {
            return {

                cidades: [
                    {
                        nome: "Bilac"
                    }
                ],
                cidadeSelecionada: {
                    nome: "Bilac"
                },

                avaliacoes: [
                    {
                        descricao: "Bilac - Avaliação diagnóstica 2019"
                    }
                ],
                avaliacaoSelecionada: {
                    descricao: "Bilac - Avaliação diagnóstica 2019"
                },

                turmas: [1,2,3,4,5,6,7,8,9],
                turmaSelecionada: 1 ,
            }
        },
        methods: {
            graficos() {
                this.$router.push('/relatorio')
            }
        }
    }
</script>

<style>

</style>
